import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Brain, Rocket } from 'lucide-react';
import InteractiveQuiz from './InteractiveQuiz';
import AuthModal from './auth/AuthModal';

// Optimized Hero Background URL with lower quality (q=50)
const HERO_BG_IMAGE = 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=50';

export default function Hero() {
  const [showAuthModal, setShowAuthModal] = useState(false);

  return (
    <div className="relative overflow-hidden bg-gradient-to-b from-indigo-900 via-purple-900 to-transparent text-white">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-30"
        style={{ backgroundImage: `url(${HERO_BG_IMAGE})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-indigo-900/80 via-purple-900/80 to-transparent" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <h1 className="text-3xl sm:text-4xl md:text-6xl font-bold tracking-tight mb-6 md:mb-8">
            Zaplanuj swoją przyszłość z AI.<br />
            <span className="text-purple-300">Wymarzona ścieżka kariery w 5 minut.</span>
          </h1>
          <p className="mt-4 md:mt-6 text-lg sm:text-xl md:text-2xl text-gray-300/90 max-w-3xl mx-auto">
            Nasze narzędzie analizuje rynek pracy i dopasowuje Twoje predyspozycje do najbardziej perspektywicznych zawodów w Polsce.
          </p>
        </motion.div>

        <InteractiveQuiz onShowAuth={() => setShowAuthModal(true)} />

        <div className="max-w-4xl mx-auto px-4 mt-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="relative bg-gradient-to-br from-purple-600/60 to-indigo-600/60 backdrop-blur-sm rounded-2xl p-8 text-center overflow-hidden"
          >
            {/* Abstract background shapes */}
            <div className="absolute top-0 left-0 w-full h-full">
              <div className="absolute top-0 right-0 w-64 h-64 bg-purple-400/20 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" />
              <div className="absolute bottom-0 left-0 w-48 h-48 bg-indigo-400/20 rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2" />
            </div>

            {/* Content */}
            <div className="relative z-10">
              <div className="bg-white/20 rounded-full p-4 w-20 h-20 mx-auto mb-6">
                <Rocket className="w-12 h-12 text-white mx-auto" />
              </div>
              <h2 className="text-2xl font-bold text-white mb-4">
                Wyprzedź 95% społeczeństwa!
              </h2>
              <p className="text-gray-100 mb-4 max-w-2xl mx-auto">
                System edukacji nie przygotował Cię do ondalezienia wymarzonej ścieżki kariery. Tutaj odkryjesz swoją prawdziwą ścieżkę w erze AI i automatyzacji.
              </p>
              <p className="text-sm text-gray-200 font-medium">
                Dołącz do tysięcy osób, które już odkryły swoją ścieżkę kariery
              </p>
            </div>
          </motion.div>
        </div>
      </div>

      <AuthModal isOpen={showAuthModal} onClose={() => setShowAuthModal(false)} />
    </div>
  );
}
